// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.5C10.8095 0.5 9.75936 1.09427 9.12759 2H2.5V22H21.5V2H14.8724C14.2406 1.09427 13.1905 0.5 12 0.5ZM17 7V9H7V7H17ZM17 11V13H7V11H17ZM14 17H7V15H14V17Z"}}]};

const AssignmentFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'assignment-filled',
    ref,
    icon: element,
  },
));

AssignmentFilledIcon.displayName = 'AssignmentFilledIcon';

export default AssignmentFilledIcon;
